"use strict";

require("core-js/modules/es6.symbol.js");
require("core-js/modules/es6.string.iterator.js");
require("core-js/modules/es6.object.to-string.js");
require("core-js/modules/es6.array.iterator.js");
require("core-js/modules/web.dom.iterable.js");
require("core-js/modules/es6.object.define-property.js");
require("core-js/modules/es6.weak-map.js");
require("core-js/modules/es6.object.get-own-property-descriptor.js");
require("core-js/modules/es6.object.assign.js");
require("core-js/modules/es6.array.slice.js");
require("core-js/modules/es6.function.name.js");
require("core-js/modules/es6.array.from.js");
require("core-js/modules/es6.array.is-array.js");
require("core-js/modules/es6.array.index-of.js");
require("core-js/modules/es6.object.keys.js");
require("core-js/modules/es6.object.freeze.js");
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lottieReactWeb = _interopRequireDefault(require("lottie-react-web"));
var _parseUnit3 = _interopRequireDefault(require("parse-unit"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var options = Object.freeze({
  animationData: require("./animationData.json"),
  autoplay: false,
  loop: true
});
var NightModeToggle = function NightModeToggle(_ref) {
  var size = _ref.size,
    checked = _ref.checked,
    onChange = _ref.onChange,
    speed = _ref.speed,
    extraProps = _objectWithoutProperties(_ref, ["size", "checked", "onChange", "speed"]);
  var ref = (0, _react.useRef)();
  var _useState = (0, _react.useState)(function () {
      return 0;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    progress = _useState2[0],
    setProgress = _useState2[1];
  var _parseUnit = (0, _parseUnit3["default"])(size),
    _parseUnit2 = _slicedToArray(_parseUnit, 2),
    sizeValue = _parseUnit2[0],
    sizeUnit = _parseUnit2[1];
  var segments = checked ? {
    segments: [2, 96]
  } : null;
  (0, _react.useEffect)(function () {
    if (progress >= .5) {
      if (checked) {
        ref.current.anim.pause();
      } else if (ref.current.anim.isPaused) {
        ref.current.anim.play();
      }
    } else if (!checked) {
      ref.current.anim.pause();
    }
  }, [checked, progress]);
  (0, _react.useEffect)(function () {
    !!checked && ref.current.anim.setCurrentRawFrameValue(48);
  }, []);
  var _useState3 = (0, _react.useState)(function () {
      return [{
        eventName: "enterFrame",
        callback: function callback(_ref2) {
          var currentTime = _ref2.currentTime,
            totalTime = _ref2.totalTime;
          return setProgress(currentTime / totalTime);
        }
      }];
    }),
    _useState4 = _slicedToArray(_useState3, 1),
    eventListeners = _useState4[0];
  return _react["default"].createElement("button", {
    onClick: function onClick() {
      return ref.current.anim.isPaused && onChange(!checked);
    },
    style: {
      cursor: "pointer",
      overflow: "hidden",
      width: "".concat(sizeValue).concat(sizeUnit || "px"),
      height: "".concat(sizeValue * .47).concat(sizeUnit || "px"),
      appearance: "none",
      MozAppearance: "none",
      WebkitAppearance: "none",
      border: "none",
      backgroundColor: "transparent",
      padding: 0
    },
    "aria-hidden": "true"
  }, _react["default"].createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginTop: "".concat(sizeValue * -.595).concat(sizeUnit || "px"),
      marginLeft: "".concat(sizeValue * -.32).concat(sizeUnit || "px"),
      width: "".concat(sizeValue * 1.65).concat(sizeUnit || "px"),
      height: "".concat(sizeValue * 1.65).concat(sizeUnit || "px")
    }
  }, _react["default"].createElement(_lottieReactWeb["default"], _extends({
    key: "$preventGlitches",
    ref: ref,
    speed: speed,
    isClickToPauseDisabled: true,
    eventListeners: eventListeners,
    forceSegments: true,
    options: options
  }, segments))));
};
NightModeToggle.propTypes = {
  size: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  checked: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  speed: _propTypes["default"].number
};
NightModeToggle.defaultProps = {
  size: 85,
  checked: false,
  onChange: function onChange(nextValue) {
    return null;
  },
  speed: 1.3
};
var _default = (0, _react.memo)(NightModeToggle);
exports["default"] = _default;